import React from "react";
import "../css/ITSupplies.css";
// We still need the main icons, but we won't use them in the banner.
import {
  Laptop,
  Monitor,
  Wifi,
  HardDrive,
  Cpu,Printer, BatteryCharging,Server
} from "lucide-react";

// (Data updated with productImage paths as shown in Step 1)
const products = [
  {
    icon: <Laptop size={40} />,
    title: "Laptops",
    desc: "High-performance laptops for teachers, staff, labs, and administration.",
    productImage: "https://png.pngtree.com/png-vector/20250304/ourmid/pngtree-sleek-modern-laptop-with-high-resolution-display-png-image_15711292.png"
  },
  {
    icon: <Cpu size={40} />,
    title: "Desktops",
    desc: "Custom and branded desktop solutions for computer labs and offices.",
    productImage: "https://tse1.mm.bing.net/th/id/OIP.axYQNRsEWWyjeKGoeoJ6KgHaE8?r=0&rs=1&pid=ImgDetMain&o=7&rm=3"
  },
  {
    icon: <Printer size={40} />,
    title: "Printers & Scanners",
    desc: "Laser printers, inkjets, multi-function printers, and document scanners.",
    productImage: "https://static.vecteezy.com/system/resources/previews/016/865/081/non_2x/modern-style-office-device-isolated-with-clipping-path-over-white-photo.jpg"
  },
  {
    icon: <BatteryCharging size={40} />,
    title: "UPS & Power Backup",
    desc: "Reliable backup solutions for uninterrupted classroom and office operations.",
    productImage:"https://5.imimg.com/data5/SELLER/Default/2024/3/404403787/KK/US/MK/27694457/hp-max-7-5-kva-numeric-ups-500x500.jpg"
  },
  {
    icon: <Server size={40} />,
    title: "Servers & Storage",
    desc: "Secure data storage, backup servers, and institutional cloud integration.",
    productImage: "https://images.pexels.com/photos/17489153/pexels-photo-17489153.jpeg",
  },
  {
    icon: <Wifi size={40} />,
    title: "Networking Devices",
    desc: "Routers, switches, access points, and structured networking solutions.",
    productImage: "https://tse2.mm.bing.net/th/id/OIP.-8ZRJL2mCYD3EvIhmLKaogHaEK?r=0&w=1200&h=675&rs=1&pid=ImgDetMain&o=7&rm=3"
  },
  {
    icon: <Monitor size={40} />,
    title: "Projectors & Smart Displays",
    desc: "Interactive learning solutions for digital classrooms and presentations.",
    productImage: "https://img.freepik.com/premium-photo/white-projector_755184-607.jpg"
  },
  {
    icon: <HardDrive size={40} />,
    title: "Accessories & Peripherals",
    desc: "Keyboard, mouse, external drives, webcams, cables, and other essentials.",
    productImage: "https://www.pngall.com/wp-content/uploads/5/Computer-Accessories-Hardware-PNG-Image.png"
  }

];

const ITSupplies = () => {
  return (
    <div className="main-container">
      {/* Updated Banner Section */}
      <section className="banner-section">
        <div className="banner-text">
          <h1 className="banner-title">
            IT Supplies for Educational Institutions
          </h1>
          <p className="banner-subtitle">
            Powering Schools, Colleges & Universities with Cutting-Edge Technology.
          </p>
        </div>

        {/* This is the new visually appealing product display */}
        <div className="banner-visual-grid">
          {products.map((item, index) => (
            <div key={index} className="banner-image-container">
              <img src={item.productImage} alt={item.title} className="banner-product-image" />
              {/* Optional: Add small icons overlay */}
              {/* <span className="banner-icon-overlay">{item.icon}</span> */}
            </div>
          ))}
        </div>
      </section>

      {/* Main Grid Section (Simplified and updated with images) */}
      <section className="product-section">
        <div className="section-header">
          <h2 className="section-title">Our Solutions</h2>
          <p className="section-subtitle">
            Essential tech for modern education.
          </p>
        </div>

        <div className="product-grid">
          {products.map((item, index) => (
            <div key={index} className="product-card">
              <img src={item.productImage} alt={item.title} className="card-main-image" />
              <div className="card-content">
                <h3 className="card-title">{item.title}</h3>
                <p className="card-desc">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section class="why-choose-us">
        <div class="container">
          <div class="content-wrapper">
            <div>
              <h2 class="title">Why Choose eVridya IT Supplies?</h2>
              <ul class="features-list">
                <li>✔ Bulk Supply for Schools & Colleges</li>
                <li>✔ Best Price Assurance</li>
                <li>✔ Genuine Branded Products</li>
                <li>✔ Installation & Setup Support</li>
                <li>✔ AMC & Maintenance Available</li>
                <li>✔ Customized IT Solutions</li>
              </ul>
            </div>
            <div>
              <img src="https://www.pngall.com/wp-content/uploads/5/Computer-Accessories-Hardware-PNG-Image.png" />
            </div>
          </div>
        </div>
      </section>

      <section class="itservice-cta-section">
        <h2 class="itservice-cta-title">Upgrade Your Institution’s IT Infrastructure</h2>
        <p class="itservice-cta-text">Get complete IT supply solutions tailored for your institution.</p>
        <button class="itservice-cta-button">Request a Quote</button>
      </section>


    </div>
  );
};

export default ITSupplies;